export const signup = {
  acceptServicesAndPrivacyPolicy:
    '我接受<span class="via-text-link suf-link-text" data-type="TermsOfService">条款与条件</span>和<span class="via-text-link suf-link-text" data-type="PrivacyPolicy">隐私协议</span>。',
  adminUserAccounts: "2个管理员账号",
  AlreadyHaveAnAccount: "已有账号？",
  andSoMuchMore: "以及更多功能……",
  dashboardStatistics: "数据统计",
  days: "天",
  digitizedInspectionReports: "数字化的点检报告",
  driverFaceIDRegistration: "司机面部识别",
  failedToSignUp: "注册失败",
  freeAccountTips:
    '现在注册账号，开始使用<span style="font-weight: bolder; color: #DE5E1B">免费版</span>',
  GBPerConnectedVehicle: "每注册一台设备将获得1GB存储容量",
  geofencing: "电子围栏",
  liveTracking: "实时追踪",
  pleaseSelectARegion: "请选择地区",
  pleaseSelectATimeZone: "请选择时区",
  proAccountTips:
    '升级到 <span style="font-weight: bolder; color: #5641F8">专业版</span>将享有',
  saveBtnText: "注册",
  signIn: "登录",
  signUp: "注册",
  signUpActivationExpired: "激活链接已过期。未能激活您的账号。",
  signupEmailIsActivated: "您的账号已经被激活。请直接登录。",
  signupErrorDuplicateCompanyName: "注册失败。该公司名称已被使用。",
  signupErrorDuplicateEmail: "此电子邮箱已被使用。",
  signupErrorEmailCannotSignUpBeforeActive:
    "无法创建新的WorkX Connect账号。此电子邮件地址已注册过一个账号，并处于未激活状态。请在创建新账号之前完成验证过程。",
  signUpNotification: "注册通知",
  signUpNotificationContent:
    "已向{email}发送了一份通知。点击邮件中的链接，激活您的账号。",
  signupSuccessTips: "您的账号已通过验证，请登录。",
  systems: "注册的设备",
  transformYourFleetManagement: "转变您的车间管理",
  unitMonth: "月",
  unitYear: "年",
  unlimitedVehicleRegistration: "不限次的设备注册",
  unlimitedVideoUploading: "不限次的视频上传",
  users: "用户账号",
  vehicleAndDriverManagement: "设备和司机管理",
  verifyFailed: "激活失败",
  verifyFailedContent: "您的账号激活失败。请重新注册。",
};
